import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ProductTabContainerProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function ProductTabContainer({ title, children, className }: ProductTabContainerProps) {
  return (
    <div className={cn('flex w-full flex-col items-start justify-start gap-6', className)}>
      <h2 data-ea-visual-tag="h3" className="text-2xl font-medium tracking-tight sm:text-3xl">
        {title}
      </h2>
      {children}
    </div>
  );
}
